import { render, staticRenderFns } from "./TheNothingFoundStub.vue?vue&type=template&id=427a0f97&"
var script = {}
import style0 from "./TheNothingFoundStub.vue?vue&type=style&index=0&id=427a0f97&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports